
export let props = ['dialog', 'row','submitType','stationCode'];
export let model = {
  // 临时表单
  formModel: {
    // 确认状态
    auditType: 0,
    // 审核意见
    auditMsg: ''
  },
};

export let computed = {
  visible: {
    get() {
      return this.dialog;
    },
    set(v) {
      this.$emit('update:dialog', v);
    }
  }
};
